import { render, staticRenderFns } from "./OrdersEditModal.vue?vue&type=template&id=04a74138&scoped=true&"
import script from "./OrdersEditModal.vue?vue&type=script&lang=js&"
export * from "./OrdersEditModal.vue?vue&type=script&lang=js&"
import style0 from "./OrdersEditModal.vue?vue&type=style&index=0&id=04a74138&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a74138",
  null
  
)

export default component.exports